<div [innerHTML]="contentBlockWidgetConfiguration.HtmlResourceId | transloco "></div>